import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Leaf, Sparkles, Heart, SmilePlus } from 'lucide-react';
const benefits = [{
  icon: CheckCircle2,
  text: 'Rutina clara y fácil de seguir'
}, {
  icon: Leaf,
  text: 'Ingredientes simples'
}, {
  icon: Sparkles,
  text: 'Menos complicaciones'
}, {
  icon: Heart,
  text: 'Enfoque natural'
}, {
  icon: SmilePlus,
  text: 'Ideal para empezar desde cero'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Benefits() {
  return <section className="py-24 bg-white" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-4xl font-medium text-brown mb-4" data-id="element-16">
            Por qué elegir este método
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center" data-id="element-17">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className={`bg-cream rounded-2xl p-8 flex flex-col items-center text-center shadow-sm hover:shadow-md transition-shadow ${index === 3 ? 'lg:col-start-1 lg:ml-auto' : ''} ${index === 4 ? 'lg:col-start-2 lg:mr-auto' : ''}`} data-id="element-18">
                <div className="w-14 h-14 bg-sage/20 rounded-full flex items-center justify-center mb-6 text-olive" data-id="element-19">
                  <Icon size={28} strokeWidth={1.5} data-id="element-20" />
                </div>
                <h3 className="text-lg font-medium text-brown" data-id="element-21">
                  {benefit.text}
                </h3>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}